import React from 'react'

import { separator } from '@ui-kit/components/layoutComponents/Separator/styles'
import { borderColor } from '@ui-kit/styles/colors'
import { paddingY } from '@ui-kit/styles/padding'

import type { SeparatorProps } from './types'

const Separator = (props: SeparatorProps) => {
  const { container, line } = separator({
    lineType: props.lineType,
  })
  return (
    <div
      className={container({
        className: paddingY({ space: props.space ?? 'medium' }),
      })}
    >
      <div
        className={line({
          className: borderColor({ color: props.color }),
        })}
      />
    </div>
  )
}

export default Separator
